import { MappedResult } from '../mapped/index.mjs';
import { Required } from './required.mjs';
// prettier-ignore
function FromProperties(P, options) {
    return globalThis.Object.getOwnPropertyNames(P).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Required(P[K2], options) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, options) {
    return FromProperties(R.properties, options);
}
// prettier-ignore
export function RequiredFromMappedResult(R, options) {
    const P = FromMappedResult(R, options);
    return MappedResult(P);
}
